import { postRequest } from 'utils/httpServices';

class dashBoardAPI {
  static getTransactionGraph = (queryData = {}, config = {}) => {
    return postRequest(`v1/graph-merchant-data`, queryData, config).catch((error) => ({
      success: false,
      data: error.response?.data || {},
      status: error.name === 'AbortError' ? 499 : error.response?.status || 400
    }));
  };

  static getMerchantList = (queryData = {}, config = {}) => {
    return postRequest(`v1/get_dashboard_partner_merchant`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static getPaymentModeList = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-payment-mode-summary`, queryData, config).catch((error) => ({
      success: false,
      data: error.response?.data || {},
      status: error.name === 'AbortError' ? 499 : error.response?.status || 400
    }));
  };

  static getChurnMerchantList = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-churn-graph`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static getFetchCommissionModeWiseGraph = (queryData = {}, config = {}) => {
    return postRequest(`v1/fetch-commission-mode-wise-graph`, queryData, config).catch((error) => ({
      success: false,
      data: error.response?.data || {},
      status: error.name === 'AbortError' ? 499 : error.response?.status || 400
    }));
  };

  static getFetchQuickSightApi = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-quicksight-link`, queryData, config).catch((error) => ({
      success: false,
      data: (error?.response && error?.response?.data) || {},
      status: (error?.response && error?.response?.status) || 400
    }));
  };

  static getTopMerchantsTransactionGraphApi = (queryData = {}, config = {}) => {
    return postRequest(`v1/top-merchant-by-transaction`, queryData, config).catch((error) => ({
      success: false,
      data: (error?.response && error?.response?.data) || {},
      status: (error?.response && error?.response?.status) || 400
    }));
  };

  static getTopMerchantsCommissionGraphApi = (queryData = {}, config = {}) => {
    return postRequest(`v1/top-merchant-by-commission`, queryData, config).catch((error) => ({
      success: false,
      data: (error?.response && error?.response?.data) || {},
      status: (error?.response && error?.response?.status) || 400
    }));
  };
}
export default dashBoardAPI;
